import { useEffect, Component } from "react";
import Lenis from "lenis";
import DisclaimerRibbon from "@/components/DisclaimerRibbon";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    componentDidCatch(error) {
        console.error(error);
    }
    render() {
        if (this.state.err) {
            return (
                <div className="min-h-screen bg-obsidian text-cream flex items-center justify-center p-8 text-center font-sans">
                    <p>Algo deu errado. Por favor, recarregue a página.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="bg-obsidian text-cream min-h-screen">
                <DisclaimerRibbon />
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Services />
                    <Gallery />
                    <Testimonials />
                    <Contact />
                </main>
                <Footer />
                <WhatsAppFloat />
                <div aria-hidden="true" className="grain-overlay" />
            </div>
        </ErrorBoundary>
    );
}

export default App;
